import axios from 'axios';
function obtenerPopups() {
  return axios.get("/obtener_popups")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function crearPopup(popup) {
  try {
    const response = axios.post('/crear_popup', popup, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function actualizarPopup(popup) {
  return axios.post("/actualizar_popup", popup)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function habilitarPopup(popup) {
  return axios.post("/habilitar_popup", popup)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarPopup(popupId) {
  return axios.post("/eliminar_popup", { id: popupId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando popup:", error);
      throw error;
    });
}
export {obtenerPopups, crearPopup, actualizarPopup, habilitarPopup, eliminarPopup};
